import { Component } from '@angular/core';
@Component({
    selector: 'my-app',
    template: '<h1>My First Angular 2 App after change</h1>'
})
export class AppComponent { }
